import './Home.scss';
import React from 'react';

import SubscriptionPlansBlock from './SubscriptionPlansBlock/SubscriptionPlansBlock';
import { apiV2 } from '../../api/ApiV2';

const Home = () => (
  <div>
    <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
      <h1 className="h2">Dashboard</h1>
      <div className="btn-toolbar mb-2 mb-md-0">
        <div className="btn-group me-2">
          <button
            type="button"
            className="btn btn-sm btn-outline-secondary"
            onClick={() => {
              const url =
                apiV2.host +
                '/app-api/download-price?token=' +
                apiV2.getToken();
              window.open(url, '_blank')?.focus();
            }}
          >
            <i className="fa-solid fa-file-export" />
            Download price
          </button>
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-12">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/sXcHjSz9cwM?si=0w1qdpGiQc4spEl0"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        ></iframe>
      </div>
    </div>
    <SubscriptionPlansBlock />
  </div>
);

export default Home;
